import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCurrentFrame = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M15.8307 5H4.16406C3.47371 5 2.91406 5.55964 2.91406 6.25V13.75C2.91406 14.4404 3.47371 15 4.16406 15H15.8307C16.5211 15 17.0807 14.4404 17.0807 13.75V6.25C17.0807 5.55964 16.5211 5 15.8307 5Z",
			stroke: "#545F7E",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 2.91602V17.0827",
			stroke: "#545F7E",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgCurrentFrame);
export default ForwardRef;
